export var Star;
(function (Star) {
    Star[Star["EMPTY_STAR"] = 0] = "EMPTY_STAR";
    Star[Star["HALF_STAR"] = 1] = "HALF_STAR";
    Star[Star["FULL_STAR"] = 2] = "FULL_STAR";
})(Star || (Star = {}));
